import { FETCH_ALL_PROVINCES_REQUEST, FETCH_ALL_PROVINCES_SUCCESS, FETCH_ALL_PROVINCES_ERROR } from '../constants/ActionTypes';

export default function isFetchingAllProvinces(state = false, action) {
    switch (action.type) {
        case FETCH_ALL_PROVINCES_REQUEST:
            return true;
        case FETCH_ALL_PROVINCES_SUCCESS:
        case FETCH_ALL_PROVINCES_ERROR:
            return false;
        default:
            return state;
    }
}
